import React, { useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import Switch from 'react-switch'

import Header from '../../components/Header'
import Button from '../../components/Button'
import Dots from './components/Dots'

import welcomeEnd from '../../assets/welcome-end.svg'
import frame1 from '../../assets/frame1_v1.png'
import frame2 from '../../assets/frame2_v1.png'
import welcomeWallet from '../../assets/welcome-wallet.svg'
import welcomeHandPork from '../../assets/welcome-hand-pork.svg'
import { Container, Carousel, CarouselBox, BtnVoltar } from './styles'

const BemVindo: React.FC = () => {
  const [acceptTerms, setAcceptTerms] = useState(true)

  const history = useHistory()
  const [quantity] = useState(3)
  const [active, setActive] = useState(0)

  const handleSetProximo = useCallback(() => {
    const newActive = active + 1
    if (newActive < quantity) {
      setActive(newActive)
    }
  }, [active, quantity])

  const handleSetAnterior = useCallback(() => {
    const newActive = active - 1
    if (newActive >= 0) {
      setActive(newActive)
    }
  }, [active])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  const handleStart = useCallback(async () => {
    history.push('/contribution')
  }, [history])

  // useEffect(() => {
  //   localStorage.removeItem('@Serpros:acceptTerms')
  //   localStorage.removeItem('@Serpros:authorizeTitularPayment')
  //   localStorage.removeItem('@Serpros:configData')
  //   localStorage.removeItem('@Serpros:goalsSelected')
  //   localStorage.removeItem('@Serpros:PercentualValuePercent')
  //   localStorage.removeItem('@Serpros:receiveTypeSelected')
  //   localStorage.removeItem('@Serpros:TimeValueYears')
  //   localStorage.removeItem('@Serpros:totalRentability')
  //   localStorage.removeItem('@Serpros:userData')
  //   localStorage.removeItem('@Serpros:userDetails')
  // }, [])

  const openVideo = useCallback(() => {
    window.open(
      'https://www.youtube.com/watch?v=yffHzGr32CU&ab_channel=SerprosFundoMultipatrocinado',
      '_blank',
    )
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Carousel>
          <CarouselBox isActive={active === 0}>
            <div className="f1" style={{ backgroundImage: `url(${frame1})` }}>
              <h2 className="titleF1">
                Seja qual for seu objetivo de futuro, o Ser+ te ajudará a
                realizá-lo!
              </h2>
              <p className="textF1">
                Faça uma simulação e veja como o Ser+ pode ser vantajoso para o
                seu planejamento financeiro e te ajudar a realizar os seus
                sonhos e os da sua família!
              </p>
              <button type="button" onClick={openVideo}>
                Assistir ao vídeo do Ser+
              </button>
              <div className="text">
                <p>
                  Ao continuar navegando no site, você concorda com as condições
                  de{' '}
                  <a
                    href="https://serpros.com.br/wp-content/uploads/2023/10/Termo_Privacidade_2022.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacidade
                  </a>{' '}
                  e{' '}
                  <a
                    href="https://serpros.com.br/wp-content/uploads/2023/10/Termo_de_Uso_Site_2.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Termo de Uso
                  </a>{' '}
                  do site do Serpros
                </p>
              </div>
            </div>
            {/* <img src={welcomeWallet} alt="Carteira" /> */}
            {/* <img src={frame1} alt="f1" /> */}
            {/* <strong>Quer ter uma aposentadoria de verdade?</strong>
            <p>
              Descubra aqui como você pode ficar financeiramente bem no futuro!
            </p>
            <small>
              Fique tranquilo. Todos os seus dados são privados e estão
              protegidos por nossa{' '}
              <a
                href="https://serpros.com.br/wp-content/uploads/2020/11/TERMO-DE-PRIVACIDADE_SERPROS-V2.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                política de privacidade
              </a>
              .
            </small> */}
          </CarouselBox>

          <CarouselBox isActive={active === 1}>
            <div className="f2" style={{ backgroundImage: `url(${frame2})` }}>
              <h2 className="titleF2">CHEGOU A HORA DE VOCÊ SER+</h2>
              <p className="textF2">Investir no SER+ vai te oferecer:</p>
              <p className="textF2-2">
                + flexibilidade <br />
                + benefícios fiscais <br />
                + renda futura <br />
                + possibilidades de uma nova carreira <br />
                + proteção familiar
                <br />E muito + !
              </p>
            </div>
          </CarouselBox>

          <CarouselBox isActive={active === 2}>
            <div className="f1" style={{ backgroundColor: '#F5F5F5' }}>
              <p className="title">Ser + é simples e flexível! </p>
              <p className="text">
                <strong className="subtitle">
                  Surgiu algum imprevisto financeiro?
                </strong>
                <br />
                <br />
                Por ser um plano bastante flexível, você conseguirá encontrar a
                solução que mais se encaixa para a sua necessidade, seja um
                resgate parcial, a suspensão temporária de até 24 meses da
                contribuição, um benefício temporário ou o seu benefício de
                renda mensal.
              </p>
              <p className="lasttext">
                O Ser + é o plano perfeito para ajudar na realização dos seus
                sonhos!
              </p>
              <div className="text">
                <p>
                  Ao continuar navegando no site, você concorda com as condições
                  de{' '}
                  <a
                    href="https://serpros.com.br/wp-content/uploads/2023/10/Termo_Privacidade_2022.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacidade
                  </a>{' '}
                  e{' '}
                  <a
                    href="https://serpros.com.br/wp-content/uploads/2023/10/Termo_de_Uso_Site_2.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Termo de Uso
                  </a>{' '}
                  do site do Serpros
                </p>
              </div>
            </div>
            {/* <img src={welcomeEnd} alt="Carteira" />
            <strong>Aqui tudo é simples e direto!</strong>
            <p>
              Surgiu algo inesperado? <br />
              Te damos a opção de fazer resgates parciais a partir do 3º ano.
            </p>
            <div>
              <small>
                Ao continuar navegando no site, você concorda com as condições
                de{' '}
                <a
                  href="https://serpros.com.br/wp-content/uploads/2020/11/TERMO-DE-PRIVACIDADE_SERPROS-V2.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacidade
                </a>{' '}
                e{' '}
                <a
                  href="https://serpros.com.br/wp-content/uploads/2021/09/Termo_de_Uso_Site_2.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Termos de uso
                </a>{' '}
                do site da Serpros.
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={22}
                width={44}
                handleDiameter={18}
                offColor="#FAB2B3"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div> */}
          </CarouselBox>
        </Carousel>

        <Dots quantity={quantity} active={active} />
        <Button
          color="blue"
          onClick={handleSetProximo}
          isVisible={active + 1 !== quantity}
        >
          Próximo
        </Button>
        <Button
          color="blue"
          onClick={handleStart}
          disabled={!acceptTerms}
          isVisible={active + 1 === quantity}
        >
          Começar
        </Button>

        {active > 0 && (
          <BtnVoltar type="button" onClick={handleSetAnterior}>
            &lt; Anterior
          </BtnVoltar>
        )}
      </Container>
    </>
  )
}

export default BemVindo
